import { inject, Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs';

import { CURRENT_CLIENT_ID_KEY } from '../models';

@Injectable({ providedIn: 'root' })
export class NavigationService {
  currentUrl = '';
  previousUrl = '';

  get route() {
    let route = this.router.routerState.root;

    while (route.firstChild) {
      route = route.firstChild;
    }

    return route;
  }

  private router = inject(Router);

  constructor() {
    this.router.events
      .pipe(filter(e => e instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        this.previousUrl = this.currentUrl;
        this.currentUrl = event.url.split('?')[0];
      });
  }

  getCurrentClientId() {
    return new URLSearchParams(window.location.search).get(CURRENT_CLIENT_ID_KEY) ?? '';
  }
}
